import ExpressedInterestForm from './ExpressedInterestForm';

export default ExpressedInterestForm;
